export interface Role {
  id: number;
  name: string;
  description: string;
}

export interface User {
  id: number;
  email: string;
  is_active: boolean;
  is_superuser: boolean;
  is_verified: boolean;
  roles: Role[];
}

export const ROLE_NAMES = {
  ADMIN: 'admin',
  AUTHORIZED_DEPOSITARY: 'authorized_depositary',
  REGISTRAR: 'registrar',
  OPERATOR: 'operator_cd',
  CD_ACCOUNTANT: 'cd_accountant',
  USER_ADMIN: 'useradmin',
} as const;

export type RoleName = typeof ROLE_NAMES[keyof typeof ROLE_NAMES];